import React from 'react'
import { OrderWidgetConfig, getOrderingWidgetData } from '@meniudigital/shared'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBolt } from '@fortawesome/free-solid-svg-icons'
import { Wrapper } from './styles'

type Props = {
  config: OrderWidgetConfig
  restaurantName: string
  showLabel?: boolean
}

export default function OrderWidgetPreview({ config, restaurantName, showLabel = false }: Props) {
  // Get all computed data from shared utilities
  const data = getOrderingWidgetData(config, restaurantName)

  const {
    websiteButton,
    phoneButton,
    glovoButton,
    boltButton,
    woltButton,
    hasActiveButtons,
    hasWebsite,
    buttonSize,
    websiteText,
    title,
    discountBadgeClass,
  } = data

  return (
    <Wrapper>
      <div className="order-widget-preview-wrapper">
        <div className="preview-section">
          <img src="/misc/upload-image-bg-min.jpeg" alt="Preview background" className="preview-background" />
          <div
            className="ordering-widget"
            style={
              {
                '--button-size': `${buttonSize}px`,
                '--icon-mask-url': `url('masks/icon-mask.svg')`,
              } as React.CSSProperties
            }
          >
            <h4>{title}</h4>
            <div className="order-links">
              {hasActiveButtons ? (
                <>
                  {(websiteButton?.isEnabled || phoneButton?.isEnabled) && (
                    <div className="website-and-phone-links">
                      {websiteButton?.isEnabled && websiteButton.url && (
                        <a
                          href={websiteButton.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="order-link expanded"
                          title="Website"
                        >
                          <img src="/icons/external-link.svg" alt="Website" loading="lazy" />
                          <span>{websiteText}</span>
                        </a>
                      )}

                      {phoneButton?.isEnabled && phoneButton.url && (
                        <a
                          href={`tel:${phoneButton.url}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={`order-link phone ${!hasWebsite ? 'expanded' : ''}`}
                          title="Telefon"
                        >
                          <img src="/icons/phone-ios.png" alt="Phone" loading="lazy" />
                          {!hasWebsite && <span className="phone-number">{phoneButton.url.replace(/\s/g, '')}</span>}
                        </a>
                      )}

                      {(config.discountPercent || 0) > 0 && (websiteButton?.isEnabled || phoneButton?.isEnabled) && (
                        <div className={`discount-badge ${discountBadgeClass}`}>
                          <span>-{config.discountPercent}%</span>
                          <img src="/icons/discount.svg" className="discount-icon" alt="Discount" loading="lazy" />
                        </div>
                      )}
                    </div>
                  )}

                  {glovoButton?.isEnabled && glovoButton.url && (
                    <a
                      href={glovoButton.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="order-link"
                      title="Glovo delivery"
                    >
                      <img src="/icons/glovo.png" alt="Glovo delivery" loading="lazy" />
                    </a>
                  )}

                  {boltButton?.isEnabled && boltButton.url && (
                    <a
                      href={boltButton.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="order-link"
                      title="Bolt Food delivery"
                    >
                      <img src="/icons/bolt-food.png" alt="Bolt Food delivery" loading="lazy" />
                    </a>
                  )}

                  {woltButton?.isEnabled && woltButton.url && (
                    <a
                      href={woltButton.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="order-link"
                      title="Wolt delivery"
                    >
                      <img src="/icons/wolt.png" alt="Wolt delivery" loading="lazy" />
                    </a>
                  )}
                </>
              ) : (
                <>
                  <div className="placeholder-button"></div>
                  <div className="placeholder-button"></div>
                  <div className="placeholder-button"></div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {showLabel && (
        <p className="preview-label">
          <FontAwesomeIcon icon={faBolt} /> Previzualizare. Modificările se vor propaga după ce faci click pe Salvează.
        </p>
      )}
    </Wrapper>
  )
}
